import React from "react";

/**
 * The theme components only imports it's theme CSS-file. These components are lazy
 * loaded, to enable "code splitting" (in order to avoid the themes being bundled together)
 */
const ThemeAdminWeb = React.lazy(() => import("./Theme"));

const ThemeSelector = ({ children, cssConfig }) => (
  <>
    {/* Conditionally render theme, based on the current client context */}
    <React.Suspense fallback={() => null}>
      { cssConfig == "admin" && <ThemeAdminWeb />}
    </React.Suspense>

    {children}
  </>
);

export default ThemeSelector;
